import React from 'react';

export const UnvalidatedStyles = {
  form: {
    flex: 1,
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  } as React.CSSProperties,
};
